<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button
                                class="btn btn-secondary"
                                @click="
                                    getHourlySalesData(
                                        '/api/generateHourlySalesData'
                                    )
                                "
                            >
                                <i class="fa fa-refresh"></i> Refresh
                            </button>
                            &nbsp;
                            <button
                                class="btn btn-secondary"
                                @click="copyTable"
                            >
                                <i class="fas fa-copy"></i> Copy Table
                            </button>
                            &nbsp;
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.from_date"
                                            placeholder="From date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.to_date"
                                            placeholder="To date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Division:</span
                                        >
                                        <v-select
                                            v-model="params.division"
                                            class="form-control"
                                            type="text"
                                            label="division_name"
                                            :options="divisions"
                                            :reduce="
                                                (divisions) =>
                                                    divisions.division_name
                                            "
                                            name="division"
                                            placeholder="Select Division Category"
                                            :value="
                                                (divisions) =>
                                                    divisions.division_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Category:</span
                                        >
                                        <v-select
                                            v-model="params.item_category"
                                            :options="linkages"
                                            label="category_name"
                                            :reduce="
                                                (linkages) =>
                                                    linkages.category_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Product:</span
                                        >
                                        <v-select
                                            v-model="params.product"
                                            :options="products"
                                            label="product_name"
                                            :reduce="
                                                (products) =>
                                                    products.product_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Brands:</span
                                        >
                                        <v-select
                                            v-model="params.brand"
                                            class="form-control"
                                            type="text"
                                            label="brand_name"
                                            :options="brands"
                                            :reduce="
                                                (brands) => brands.brand_name
                                            "
                                            name="brand"
                                            placeholder="Select Brand"
                                            :value="
                                                (brands) => brands.brand_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>

                                <div
                                    class="col-sm-4"
                                    v-if="
                                        $gate.isZonalManager() ||
                                        $gate.isMISAdmin() ||
                                        $gate.isSecondaryMISAdmin() ||
                                        $gate.isCCManager() ||
                                        $gate.isCCAgent() ||
                                        $gate.isOnlineSalesManager() ||
                                        $gate.isOnlineSalesAssociate() ||
                                        $gate.isServiceAdmin()
                                    "
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Branch:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.branch"
                                            multiple
                                        >
                                            <option
                                                v-for="branch in branches"
                                                :value="branch.branch_code"
                                            >
                                                {{ branch.branch }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Salesperson:</span
                                        >
                                        <v-select
                                            v-model="params.created_by"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Accountant:</span
                                        >
                                        <v-select
                                            v-model="params.assigned_to"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="
                                                getHourlySalesData(
                                                    '/api/generateHourlySalesData'
                                                )
                                            "
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            Displaying Results with filters: From {{ this.params.from_date }} to
            {{ this.params.to_date }} for branches {{ params.branch }}
            <br />
            <br />
            <div class="10">
                <div class="row">
                    <div class="col-md-11">
                        <div class="row" align="center">
                            <div class="col-lg-6 col-12">
                                <!-- small box -->
                                <div class="small-box bg-secondary">
                                    <div class="inner">
                                        <h4>{{ getTotalQuantity() }}</h4>
                                        <p>Total Quantity</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-person-add"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-12">
                                <!-- small box -->
                                <div class="small-box bg-secondary">
                                    <div class="inner">
                                        <h4>
                                            {{ getTotalValue() | dotNumbers }}
                                        </h4>
                                        <p>Total Value</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-pricetag"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body table-responsive">
                        <div
                            v-if="show_quantity == 1"
                            class="custom-control custom-switch"
                        >
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="show_quantity"
                                checked
                                @input="toggleValueVisibility"
                            />
                            <label
                                class="custom-control-label"
                                :for="show_quantity"
                                >Showing Quantity</label
                            >
                        </div>
                        <div
                            v-if="show_quantity == 0"
                            class="custom-control custom-switch"
                        >
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                :id="show_quantity"
                                checked
                                @input="toggleValueVisibility"
                            />
                            <label
                                class="custom-control-label"
                                :for="show_quantity"
                                >Not Showing Quantities</label
                            >
                        </div>
                        <br /><br />
                        <table class="table table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th>Date</th>
                                    <th>Branch</th>
                                    <th>Sales Person Name</th>
                                    <!--                                    <th>UID</th>-->
                                    <th
                                        v-for="slot in uniqueSlots"
                                        :key="slot"
                                        @click="sortData(slot)"
                                    >
                                        {{ slot }}
                                    </th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(groupedEntry, index) in sortedData"
                                    :key="index"
                                >
                                    <td>{{ groupedEntry.Date }}</td>
                                    <td>{{ groupedEntry.Branch }}</td>
                                    <td>
                                        {{ groupedEntry["Sales Person Name"] }}
                                    </td>
                                    <!--                                    <td>{{ groupedEntry.UID }}</td>-->
                                    <td
                                        v-for="slot in uniqueSlots"
                                        :key="slot"
                                        @click="
                                            viewDetailedHourlyReport(
                                                groupedEntry.Date,
                                                groupedEntry.Branch,
                                                groupedEntry.UID
                                            )
                                        "
                                    >
                                        {{
                                            groupedEntry[`${slot}_value`] !==
                                            undefined
                                                ? groupedEntry[`${slot}_value`]
                                                : 0
                                        }}
                                        <span v-if="show_quantity == 1"
                                            >(
                                            {{
                                                groupedEntry[
                                                    `${slot}_quantity`
                                                ] !== undefined
                                                    ? groupedEntry[
                                                          `${slot}_quantity`
                                                      ]
                                                    : 0
                                            }}
                                            )</span
                                        >
                                    </td>
                                    <td>
                                        {{
                                            groupedEntry.dailyValue | dotNumbers
                                        }}
                                        <span v-if="show_quantity == 1"
                                            >(
                                            {{ groupedEntry.dailyQuantity }}
                                            )</span
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer"></div>
                </div>
            </div>
        </section>
        <!-- /.content -->

        <loading :show="lshow" :label="llabel"> </loading>
        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import { parse } from "postcss";
import Pagination from "../../pagination.vue";
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { loading: loading, pagination: Pagination },

    created() {
        this.params.from_date = new Date().toISOString().slice(0, 10);
        this.params.to_date = new Date().toISOString().slice(0, 10);
        if (typeof this.$route.params.branch !== "undefined") {
            this.params.branch[0] = this.$route.params.branch;
        }
        if (typeof this.$route.params.from_date !== "undefined") {
            this.params.from_date = this.$route.params.from_date;
        }
        if (typeof this.$route.params.to_date !== "undefined") {
            this.params.to_date = this.$route.params.to_date;
        }
        this.getCampaignMedias();
        this.getBranches();
        this.getSalesmen();
        this.getLinkages();
        this.getProducts();
        this.getBrandsList();
        this.getDivisions();
        // this.getGatepassStatusReport();
        this.getHourlySalesData();
    },

    data() {
        return {
            lshow: false,
            llabel: "Updating Leads. Do not close or change this page...",
            status_report: [],
            show_quantity: true,
            sortKey: "",
            sortDirection: "asc",
            gpstatuses: [],
            linkages: [],
            products: [],
            rawData: [],
            branches: [],
            dataBranches: [],
            medias: [],
            reasons: [],
            timeSlots: [],
            salesmen: [],
            brands: [],
            divisions: [],
            sortBy: "Converted",
            sortAscending: false,
            total_value: "0",
            total_quantity: "0",
            params: new Form({
                status: "",
                from_date: "",
                to_date: "",
                name: "",
                type: "",
                requirement: "",
                campaign_media: "",
                product: "",
                division: "",
                brand: "",
                entry_point: "",
                phone_number: "",
                turnaway_reason: "",
                is_leadsheet_item: "",
                item_category: "",
                status_updated_on: null,
                status_notes: null,
                assignment: "",
                branch: [],
                summary: "",
                results: "",
                created_by: "",
                assigned_to: "",
            }),
        };
    },

    computed: {
        // Extract unique hourslots from the data and sort them
        uniqueSlots() {
            const slots = new Set();
            this.rawData.forEach((entry) => {
                if (entry.hourslot) {
                    slots.add(entry.hourslot);
                }
            });
            // Convert the Set to an array, sort it, and return
            return Array.from(slots).sort();
        },
        // Group data by Date, Branch, Sales Person, and UID
        groupedData() {
            const grouped = {};
            const dailyTotals = {}; // Track daily totals for each executive

            this.rawData.forEach((entry) => {
                const key = `${entry.Date}-${entry.Branch}-${entry["Sales Person Name"]}-${entry.UID}`;

                // Initialize the daily total if it doesn't exist
                if (!dailyTotals[key]) {
                    dailyTotals[key] = {
                        Date: entry.Date,
                        Branch: entry.Branch,
                        "Sales Person Name": entry["Sales Person Name"],
                        UID: entry.UID,
                        dailyQuantity: 0,
                        dailyValue: 0,
                    };
                }

                // Update daily totals for each entry
                dailyTotals[key].dailyQuantity += parseInt(
                    entry.quantity || 0,
                    10
                );
                dailyTotals[key].dailyValue += parseFloat(entry.value || 0, 10);

                // Update hourly totals
                const quantityKey = `${entry.hourslot}_quantity`;
                const valueKey = `${entry.hourslot}_value`;

                // Initialize the grouped entry if it doesn't exist
                if (!grouped[key]) {
                    grouped[key] = {
                        Date: entry.Date,
                        Branch: entry.Branch,
                        "Sales Person Name": entry["Sales Person Name"],
                        UID: entry.UID,
                    };
                }

                // Update hourly totals for each entry
                grouped[key][quantityKey] =
                    (grouped[key][quantityKey] || 0) +
                    parseInt(entry.quantity || 0, 10);
                grouped[key][valueKey] =
                    (grouped[key][valueKey] || 0) +
                    parseFloat(entry.value || 0, 10);
            });

            // Round the values to 3 decimal places for display
            Object.values(grouped).forEach((entry) => {
                for (const key in entry) {
                    if (key.includes("_value")) {
                        entry[key] = parseFloat(entry[key]).toFixed(2);
                    }
                }
            });

            // Merge daily totals into grouped data
            Object.values(dailyTotals).forEach((total) => {
                const key = `${total.Date}-${total.Branch}-${total["Sales Person Name"]}-${total.UID}`;
                grouped[key].dailyQuantity = total.dailyQuantity;
                grouped[key].dailyValue = total.dailyValue;
            });

            return Object.values(grouped);
        },
        // Sort data based on the selected hourslot and sorting order
        sortedData() {
            if (this.sortKey) {
                const multiplier = this.sortDirection === "asc" ? 1 : -1;
                return this.groupedData.sort(
                    (a, b) =>
                        (a[`${this.sortKey}_value`] -
                            b[`${this.sortKey}_value`]) *
                        multiplier
                );
            } else {
                return this.groupedData;
            }
        },
    },

    methods: {
        reset() {
            this.params.reset();
            this.getHourlySalesData();
        },

        sortData(slot) {
            if (this.sortKey === slot) {
                this.sortDirection =
                    this.sortDirection === "asc" ? "desc" : "asc";
            } else {
                this.sortKey = slot;
                this.sortDirection = "asc";
            }
        },

        toggleValueVisibility() {
            if (this.show_quantity == 0) this.show_quantity = 1;
            else this.show_quantity = 0;
        },

        copyTable() {
            const table = document.querySelector(".table"); // Select the table element using its class
            const range = document.createRange();
            range.selectNode(table);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("copy");
            selection.removeAllRanges();
            alert("Table content copied to clipboard!");
        },

        getCampaignMedias() {
            axios.post("/api/getCampaignMedias").then((response) => {
                this.medias = response.data;
            });
        },

        getSalesmen() {
            axios.post("/api/getBranchCallAgents").then((response) => {
                this.salesmen = response.data;
            });
        },

        getReasons() {
            axios.post("/api/getAllTAR").then((response) => {
                this.reasons = response.data;
            });
        },

        getLinkages(url = "/api/getActiveCategoryProductLinks") {
            axios.post(url).then((response) => {
                this.linkages = response.data.data;
            });
        },

        getProducts(url = "/api/getMasterProductList") {
            axios.post(url).then((response) => {
                this.products = response.data;
            });
        },

        getDivisions() {
            axios.post("/api/getMasterDivisionList").then((response) => {
                this.divisions = response.data;
            });
        },

        getBrandsList() {
            axios.post("/api/getMasterBrandsList").then((response) => {
                this.brands = response.data;
            });
        },

        getGPStatuses() {
            axios.post("/api/getGPStatuses").then((response) => {
                this.gpstatuses = response.data;
            });
        },

        getStatusCount(group, status) {
            return group.counts[status] || 0;
        },

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getHourlySalesData(url = "/api/generateHourlySalesData") {
            axios.post(url, { filters: this.params }).then((response) => {
                // this.status_report = response.data.report;
                // this.lead_sheet_items = response.data.lead_sheet_items;
                // this.sale_orders = response.data.sale_orders;
                // this.invoiced = response.data.invoiced;
                // this.configPagination(response.data.data);
                this.rawData = response.data;
                // this.total_value = response.data.total_value;
                // this.total_quantity = response.data.total_quantity;
            });
        },
        // Method to calculate the total quantity
        getTotalQuantity() {
            return this.rawData.reduce((total, entry) => {
                return total + parseInt(entry.quantity || 0, 10);
            }, 0);
        },

        // Method to calculate the total value
        getTotalValue() {
            return this.rawData.reduce((total, entry) => {
                return total + parseFloat(entry.value || 0, 10);
            }, 0);
        },

        viewDetailedHourlyReport(date, branch, uid) {
            const [day, month, year] = date.split("/");

            // Create a new Date object (Note: month is 0-indexed, so we subtract 1)
            const dateObject = new Date(year, month - 1, day);

            // Format the date as 'YYYY-MM-DD'
            const formattedDate = dateObject.toISOString().split("T")[0];
            console.log(formattedDate);
        },
    },
};
</script>
